
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Text`}</h1>
    <p>{`Use this directory to store your `}<a parentName="p" {...{
        "href": "https://mdxjs.com"
      }}>{`MDX files`}</a>{` in case they are independent from your components or when it is easier to just have the complete article text in one directory.`}</p>
    <h2>{`Usage`}</h2>
    <p>{`From `}<inlineCode parentName="p">{`@ta-interaktiv/webpack-config`}</inlineCode>{` >= 2.9.0 on, you can use content in here like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import introText from 'text/intro.mdx'
`}</code></pre>
    <p>{`Otherwise, use the relative form:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import introText from '../../text/intro.mdx'
`}</code></pre>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;